import { useState, ChangeEvent } from 'react';
import { MdDownload } from "react-icons/md";
import columns from '../columns';
import useModal from "../../../hooks/useModal";
import useModalSelecaoTalhoes from "../../../hooks/useModalSelecaoTalhoes";
import { useTableListTalhoes } from "../../../hooks/useTableListTalhoes";
import { ContainerTable, RoundedTable, SelectAllContainer, Input, SelectionSummary } from '../styles';

type Props = {
  listItem: any
}

export function TableListImpot({ listItem }: Props) {
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const { setIsOpenImportTalhoes, setImportTalhoesObject, setIsOpenImport, setIsOpen } = useModal();
  const { setCopyWithImportObject, setIsCopyWithImport } = useModalSelecaoTalhoes();
  const { setIdSelecao } = useTableListTalhoes();

  function handleClose() {
    setIsOpenImportTalhoes(false);
    setIsOpenImport(false);
  }

  function handleSelectAll(event: ChangeEvent<HTMLInputElement>) {
    const isChecked = event.target.checked;

    if (isChecked) {
      if (listItem.length > 0) {
        const allIds = listItem
        ?.filter((item: any) => !item?.jaImportado)
        ?.map((item: any) => item.idExternoPlanoOperacional);

        setSelectedItems(() => {
          const newSelected = allIds;
          return newSelected;
        });
      }
    } else {
      setSelectedItems([]);
    }
  }

  function handleSelectItem(id: string) {
    setSelectedItems((prev) => {
      const isSelected = prev.includes(id);
      const newSelected = isSelected
        ? prev.filter((itemId) => itemId !== id)
        : [...prev, id];

      return newSelected;
    });
  }

  function handleimportSelecteds() {
    if(!selectedItems?.length) return;
    const newList =  listItem?.filter((item: any) => selectedItems.includes(item.idExternoPlanoOperacional));
    setCopyWithImportObject(newList);
    setIsCopyWithImport(true);
    setIsOpen(true);
    handleClose();
  }

  return (
    <div>
      <span>{listItem?.length} Pacotes Encontrados</span>
      <SelectAllContainer>
        <Input type="checkbox" id="importSelectAll" onChange={handleSelectAll} />
        <label htmlFor="importSelectAll">Todos</label>
      </SelectAllContainer>
      <ContainerTable isOverflow>
        <RoundedTable
          style={{ marginBottom: 16 }}
          columns={columns(
            selectedItems,
            handleSelectItem,
            setIsOpenImportTalhoes,
            setImportTalhoesObject,
            setIdSelecao,
            setIsOpenImport
          )}
          dataSource={listItem}
          className="my-table"
          scroll={{ x: 'max-content', y: 316 }}
          sticky
          pagination={false}
        />
      </ContainerTable>
      {selectedItems?.length > 0 && (
        <SelectionSummary>
          <span><strong id="importSelectedCount">{selectedItems.length}</strong> pacotes selecionados</span>
          <button onClick={handleimportSelecteds}>
            <MdDownload />
            Importar Selecionados
          </button>
        </SelectionSummary>

      )}
    </div>


  )
}